import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Lock, Check, Eye, EyeOff } from "lucide-react";
import api from "./axiosConfig"; // Assure-toi que le chemin est correct

export default function ChangerMotDePasse() {
  const navigate = useNavigate();
  const phone = localStorage.getItem("customerPhone");

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" }); // type: 'success' | 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: "", type: "" });

    if (formData.newPassword.length < 4) {
      setMessage({ text: "Le nouveau mot de passe est trop court (min 4 caractères).", type: "error" });
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ text: "Les nouveaux mots de passe ne correspondent pas.", type: "error" });
      return;
    }

    try {
      setLoading(true);
      // Appel API backend
      await api.put(`/users/client/${phone}/password`, {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });

      setMessage({ text: "Mot de passe modifié avec succès !", type: "success" });
      
      // Réinitialiser le formulaire
      setFormData({ currentPassword: "", newPassword: "", confirmPassword: "" });

      // Redirection après 2 secondes
      setTimeout(() => navigate("/compte"), 2000);

    } catch (err) {
      const errorMsg = err.response?.data?.error || "Erreur lors du changement de mot de passe.";
      setMessage({ text: errorMsg, type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const InputStyle = "w-full pl-12 pr-10 py-3 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-[#f34141] focus:border-transparent outline-none transition-all";

  return (
    <div className="min-h-screen px-4 pt-6 pb-20 font-sans bg-gray-50">
      
      {/* HEADER AVEC BOUTON RETOUR */}
      <div className="flex items-center gap-4 mb-8">
        <button 
          onClick={() => navigate(-1)}
          className="p-2 transition bg-white rounded-full shadow-sm hover:bg-gray-100"
        >
          <ChevronLeft className="w-6 h-6 text-gray-700" />
        </button>
        <h1 className="text-xl font-bold text-gray-800">Sécurité</h1>
      </div>

      <div className="p-6 space-y-6 bg-white shadow-sm rounded-3xl">
        <div className="space-y-2 text-center">
            <div className="w-16 h-16 bg-red-50 text-[#f34141] rounded-full flex items-center justify-center mx-auto mb-4">
                <Lock size={32} />
            </div>
            <h2 className="text-xl font-bold text-gray-800">Changer le mot de passe</h2>
            <p className="text-sm text-gray-500">Pour sécuriser votre compte, choisissez un mot de passe fort.</p>
        </div>

        {message.text && (
          <div className={`p-4 rounded-xl text-sm font-medium text-center ${message.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'}`}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* ANCIEN MOT DE PASSE */}
          <div className="relative">
            <Lock className="absolute w-5 h-5 text-gray-400 -translate-y-1/2 left-4 top-1/2" />
            <input
              type={showPassword ? "text" : "password"}
              name="currentPassword"
              placeholder="Mot de passe actuel"
              value={formData.currentPassword}
              onChange={handleChange}
              className={InputStyle}
              required
            />
             <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute text-gray-400 -translate-y-1/2 right-4 top-1/2"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <hr className="my-2 border-gray-100"/>

          {/* NOUVEAU MOT DE PASSE */}
          <div className="relative">
            <Lock className="absolute w-5 h-5 text-gray-400 -translate-y-1/2 left-4 top-1/2" />
            <input
              type={showPassword ? "text" : "password"}
              name="newPassword"
              placeholder="Nouveau mot de passe"
              value={formData.newPassword}
              onChange={handleChange}
              className={InputStyle}
              required
            />
          </div>

          {/* CONFIRMATION */}
          <div className="relative">
            <Check className="absolute w-5 h-5 text-gray-400 -translate-y-1/2 left-4 top-1/2" />
            <input
              type={showPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirmer le nouveau mot de passe"
              value={formData.confirmPassword}
              onChange={handleChange}
              className={InputStyle}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 mt-4 bg-[#f34141] text-white font-bold rounded-xl shadow-lg hover:bg-red-600 transition-all disabled:opacity-70 flex justify-center items-center gap-2"
          >
            {loading ? "Mise à jour..." : "Mettre à jour le mot de passe"}
          </button>
        </form>
      </div>
    </div>
  );
}